import dragDropGif from 'Asset/gif/tutorial-dragdrop.gif';
import deleteHostGif from 'Asset/gif/tutorial-hapus.gif';
import addGif from 'Asset/gif/tutorial-tambah.gif';

export const TUTORIAL_COOKIE_NAME = 'smart-schedule-tutorial';

const TUTORIAL_KEYS = [
  { gif: dragDropGif, titleKey: 'dragDropScheduleTitle', descKey: 'dragDropScheduleDesc' },
  { gif: deleteHostGif, titleKey: 'deleteScheduleHostTitle', descKey: 'deleteScheduleHostDesc' },
  { gif: addGif, titleKey: 'addScheduleHostTitle', descKey: 'addScheduleHostDesc' },
];

export const buildTutorialData = (t) =>
  TUTORIAL_KEYS.map(({ gif, titleKey, descKey }) => ({
    gif,
    title: t(titleKey),
    desc: t(descKey),
  }));